import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData from "../animation-data/Onboard_text_json/data.json";
import animationDataForNonTrial from '../animation-data/Onboard_text_json/data_for_non_trial.json';

function OnboardingAnimation({isTrialUser = true}) {
  useEffect(()=>{
    lottie.loadAnimation({
      container: document.getElementById('onboarding-animation'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: isTrialUser ? animationData : animationDataForNonTrial,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet'
      }
    });
  })
  
  return(
    <div id="onboarding-animation"></div>
  )
}

export default OnboardingAnimation;